// extracted by mini-css-extract-plugin
export default {"wave":"Mascot_wave__0tTYA"};